// @flow
import {
    CLEAR_RESET_PASSWORD_ERROR,
    FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT,
    FORGOTTEN_PASSWORD_ERROR,
    FORGOTTEN_PASSWORD_READY,
    FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST,
    PASSWORD_RESET_REQUEST,
    RESET_PASSWORD,
    RESET_PASSWORD_ERROR,
    RESET_PASSWORD_READY,
    RESET_PASSWORD_SUCCESS,
    RESETTING_PASSWORD
} from './constants';

import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import type { StateType } from './types';

const initialState: StateType = {
    forgottenPasswordState: FORGOTTEN_PASSWORD_READY,
    resetPasswordState: RESET_PASSWORD_READY
};

const actionHandlers = {
    [CLEAR_RESET_PASSWORD_ERROR]: state => ({ resetPasswordState: RESET_PASSWORD_READY }),
    [FORGOTTEN_PASSWORD_READY]: handleReduce(() => ({
        forgottenPasswordState: FORGOTTEN_PASSWORD_READY
    })),
    [FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST]: handleReduce(() => ({
        forgottenPasswordState: FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST
    })),
    [FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT]: handleReduce(
        state => ({
            forgottenPasswordState: FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT
        }),
        state => ({ forgottenPasswordState: FORGOTTEN_PASSWORD_ERROR })
    ),
    [RESET_PASSWORD_READY]: handleReduce(() => ({
        resetPasswordState: RESET_PASSWORD_READY
    })),
    [RESETTING_PASSWORD]: handleReduce(
        () => ({ resetPasswordState: RESETTING_PASSWORD }),
        () => ({ resetPasswordState: RESETTING_PASSWORD })
    ),
    [PASSWORD_RESET_REQUEST]: handleReduce(() => ({
        resetPasswordState: RESETTING_PASSWORD
    })),
    [RESET_PASSWORD]: handleReduce(
        state => ({ resetPasswordState: RESET_PASSWORD_SUCCESS }),
        (state, { payload }) => ({
            resetPasswordState: RESET_PASSWORD_ERROR
        })
    )
};

export default handleActions(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/core/state/authentication/index.js